export default __webpack_public_path__ + "static/media/parentswithchild.ddcb7f370f87feeb94c2a701b2e1ac07.svg";